import {
	getReferencesRequest,
	updateReferenceRequest,
} from '../requests';
import { throttle, objectGet, objectSet } from '@/core';
import rdbClient from 'rdb-client';

async function getReferences({ state, commit }, { force } = {}) {
	commit('set', (state) => { state.loading = true; });
	try {
		if (force || state.references.length === 0) {
			await fetchReferences();
		} else {
			await throttle(fetchReferences, 'fetchReferences', 60 * 1000);
		}
	} catch (err) {
		console.error(err);
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function fetchReferences() {
		let response = await getReferencesRequest();
		commit('setReferences', response);
	}
}

async function setReferenceActive({ commit }, { reference, data }) {
	if (reference.isActive === data) return;

	let referenceClone = JSON.parse(JSON.stringify(reference));
	commit('set', () => { reference.isActive = data; });
	let patch = rdbClient.createPatch(referenceClone, reference);
	try {
		await updateReferenceRequest(reference.id, { patch });
		commit('clearErrors');
	} catch (err) {
		if (err.response) {
			commit('setErrors', { errors: err.response.data.errors, id: reference.id });
		}
		commit('set', () => { reference.isActive = referenceClone.isActive; });
		throw (err);
	}
}

async function setReference({ commit }, { reference, data, prop }) {
	let originalValue = objectGet(reference, prop);
	if (objectGet(reference, prop) === data) return;

	let referenceClone = JSON.parse(JSON.stringify(reference));
	commit('set', () => { objectSet(reference, prop, data); });
	let patch = rdbClient.createPatch(referenceClone, reference);
	try {
		await updateReferenceRequest(reference.id, { patch });
		commit('clearErrors');
	} catch (err) {
		if (err.response) {
			commit('setErrors', { errors: err.response.data.errors, id: reference.id });
		}
		commit('set', () => { objectSet(reference, prop, originalValue); });
		throw (err);
	}
}

export default {
	getReferences,
	setReferenceActive,
	setReference,
};
